import React, { Fragment } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import moment from 'moment';
import UserFullname from '~/components/userFullname/userFullname';
import { calculateTotals } from '~/utils/ingredients';

const LotSummaryCard = ({
  className,
  status,
  isSample,
  startDate,
  product,
  isConsolidated,
  currentVolume,
  volume,
  ingredients,
  createdByUser,
  startedByUser,
  completedByUser,
  permitNumber,
  wastage,
  dutyPaid,
  consolidatedLotId,
  consolidatedLot
}) => {
  const { abv } = product;
  const { grain, hops } = calculateTotals(ingredients);
  return (
    <Card className={cn(className, 'pa3')}>
      <h3 className="f4 mt0">Summary</h3>
      {dutyPaid && (
        <Fragment>
          <p className="strong">Duty has been paid</p>
        </Fragment>
      )}
      {isSample && (
        <Fragment>
          <p className="strong">This lot is being brewed for sample purposes only</p>
        </Fragment>
      )}
      {status === 'COMPLETED' && (
        <Fragment>
          <h4 className="table-header mv0">Permit number</h4>
          <p>{permitNumber}</p>
          <h4 className="table-header mv0">Wastage</h4>
          <p>{wastage}L</p>
        </Fragment>
      )}
      {isConsolidated && (
        <Fragment>
          <h4 className="table-header mv0">Volumes</h4>
          <p>
            <em>Current:</em> {currentVolume}L
          </p>
          <p>
            <em>Tank:</em> {volume}L
          </p>
        </Fragment>
      )}
      {!!consolidatedLotId && (
        <Fragment>
          <h4 className="table-header mv0">Consolidated into</h4>
          <p>
            <Link to={`/lots/${consolidatedLot.id}`}>{consolidatedLot.reference}</Link>
          </p>
        </Fragment>
      )}
      <h4 className="table-header mv0">Start date</h4>
      <p>{moment(startDate).format('dddd Do MMMM')}</p>
      <h4 className="table-header mv0">Alcohol</h4>
      <p>{abv}% ABV</p>
      <h4 className="table-header mv0">Ingredients</h4>
      <p>
        {grain.amount} {grain.measurementType.toLowerCase()} malt
      </p>
      <p>
        {hops.amount} {hops.measurementType.toLowerCase()} hops
      </p>
      <h4 className="table-header mv0">Scheduled By</h4>
      <p>
        <UserFullname user={createdByUser} />
      </p>
      {startedByUser &&
        startedByUser && (
          <Fragment>
            <h4 className="table-header mv0">Started By</h4>
            <p>
              <UserFullname user={startedByUser} />
            </p>
          </Fragment>
        )}
      {status === 'COMPLETED' &&
        completedByUser && (
          <Fragment>
            <h4 className="table-header mv0">Completed By</h4>
            <p>
              <UserFullname user={completedByUser} />
            </p>
          </Fragment>
        )}
    </Card>
  );
};

export default LotSummaryCard;



// WEBPACK FOOTER //
// ./src/components/lotSummaryCard/lotSummaryCard.jsx